
import { computed, defineComponent, PropType } from 'vue'

// @components
import CourierWorkload from '@/modules/NewDispatcher/components/CourierWorkload/index.vue'

// @types
import { CourierSector, TakeCourier } from '@/new-services/types/couriers'

export default defineComponent({
    name: 'courier-card',
    components: {
        CourierWorkload,
    },
    props: {
        courier: {
            type: Object as PropType<TakeCourier>,
            required: true,
        },
    },
    setup(props) {
        const getSectors = computed(() => {
            if (!props.courier.sectors || !props.courier.sectors.length) return '-'

            let sectors_arr: string[] = []

            props.courier.sectors.forEach((sector) => {
                if (sector) sectors_arr.push(sector.name)
            })

            return sectors_arr.join(',')
        })

        return { getSectors }
    },
})
